import {getMethod, patchMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownAccommodationContracts', request)
}

async function post(request) {
    return await postMethod('/api/ownAccommodationContracts', request)
}

async function put(request) {
    return await putMethod('/api/ownAccommodationContracts', request)
}

async function patch(id, request) {
    return await patchMethod(`/api/ownAccommodationContracts/${id}`, request)
}

export {get, post, put, patch}
